var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dish-form" },
    [
      _c("el-card", { staticClass: "form-card", attrs: { shadow: "hover" } }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("i", { staticClass: "el-icon-food" }),
            _vm._v(" "),
            _c("span", [_vm._v("订单详情")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-form",
              { attrs: { "label-width": "90px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 25 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c("el-header", [_vm._v("购货人信息")]),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "订单号" } },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.orderData.orderSn)
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.orderData.storeName)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "购货人" } },
                                          [
                                            _vm.orderData.user &&
                                            _vm.orderData.user.mobilePhone
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleViewMember(
                                                          _vm.orderData.user
                                                            .mobilePhone
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.orderData.user
                                                            .mobilePhone
                                                        ) +
                                                        "[" +
                                                        _vm._s(
                                                          _vm.orderData.user
                                                            .userId
                                                        ) +
                                                        "]\n                        "
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v("匿名用户"),
                                                ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "left-start",
                                                      title: "购货人信息",
                                                      width: "280",
                                                      trigger: "click",
                                                      "popper-class":
                                                        "buyer-info-popover",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.buyerInfoVisible,
                                                      callback: function ($$v) {
                                                        _vm.buyerInfoVisible =
                                                          $$v
                                                      },
                                                      expression:
                                                        "buyerInfoVisible",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "buyer-info-content",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "电子邮件:"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.orderData.user
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .orderData
                                                                          .user
                                                                          .email
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "账户余额:"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.orderData.user
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .orderData
                                                                          .user
                                                                          .userMoney
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "消费积分:"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.orderData.user
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .orderData
                                                                          .userExtInfo
                                                                          .payPoints
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "等级积分:"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.orderData.user
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .orderData
                                                                          .userExtInfo
                                                                          .rankPoints
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "会员等级:"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.orderData.user
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .orderData
                                                                          .user
                                                                          .userRankName ||
                                                                          (_vm
                                                                            .orderData
                                                                            .user
                                                                            .userRank ===
                                                                          0
                                                                            ? "游客卡"
                                                                            : "")
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "info-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "优惠券数量:"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.orderData.user
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .orderData
                                                                          .userExtInfo
                                                                          .surplusCoupon
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.orderData
                                                          .userAddress &&
                                                        _vm.orderData
                                                          .userAddress.length >
                                                          0
                                                          ? [
                                                              _c("div", {
                                                                staticStyle: {
                                                                  "border-top":
                                                                    "1px solid #eee",
                                                                  margin:
                                                                    "10px 0",
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.orderData
                                                                  .userAddress,
                                                                function (
                                                                  address,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: index,
                                                                      staticClass:
                                                                        "address-item",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info-label",
                                                                          staticStyle:
                                                                            {
                                                                              "text-align":
                                                                                "center",
                                                                              "margin-bottom":
                                                                                "10px",
                                                                              "margin-top":
                                                                                "10px",
                                                                              "font-weight":
                                                                                "600",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "收货人：" +
                                                                              _vm._s(
                                                                                address.consignee
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info-row",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "地址:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-value",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  address.address
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info-row",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "邮编:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-value",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  address.zipcode
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info-row",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "电话:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-value",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  address.tel
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info-row",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "手机:"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "info-value",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  address.mobile
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      index <
                                                                      _vm
                                                                        .orderData
                                                                        .userAddress
                                                                        .length -
                                                                        1
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  "border-bottom":
                                                                                    "1px dashed #eee",
                                                                                  margin:
                                                                                    "10px 0",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          slot: "reference",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.buyerInfoVisible =
                                                              !_vm.buyerInfoVisible
                                                          },
                                                        },
                                                        slot: "reference",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "[ 显示购货人信息 ]"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "pay-note-form-item",
                                            attrs: { label: "支付方式" },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.orderData.payName)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _vm.orderData.platform === "wx"
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "5px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      type: "success",
                                                      effect: "light",
                                                    },
                                                  },
                                                  [_vm._v("微信")]
                                                )
                                              : _vm.orderData.platform === "ali"
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "5px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      type: "primary",
                                                      effect: "light",
                                                    },
                                                  },
                                                  [_vm._v("支付宝")]
                                                )
                                              : _vm.orderData.platform
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "5px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      type: "info",
                                                      effect: "light",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.orderData.platform
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isEditingPayNote
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pay-note-editable",
                                                    on: {
                                                      click:
                                                        _vm.handlePayNoteEdit,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          (备注:" +
                                                        _vm._s(
                                                          _vm.orderData
                                                            .payNote || "N/A"
                                                        )
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-edit",
                                                      staticStyle: {
                                                        "margin-left": "5px",
                                                        color: "#409EFF",
                                                        cursor: "pointer",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      ")\n                        "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pay-note-input-wrapper",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("(备注:"),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("el-input", {
                                                      ref: "payNoteInput",
                                                      attrs: {
                                                        size: "mini",
                                                        placeholder:
                                                          "请输入备注",
                                                      },
                                                      on: {
                                                        blur: _vm.handlePayNoteBlur,
                                                      },
                                                      nativeOn: {
                                                        keyup: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          ) {
                                                            return null
                                                          }
                                                          return _vm.handlePayNoteEnter(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: _vm.editPayNote,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.editPayNote = $$v
                                                        },
                                                        expression:
                                                          "editPayNote",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [_vm._v(")")]),
                                                  ],
                                                  1
                                                ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "订单状态" } },
                                          [
                                            _c("span", [
                                              _c(
                                                "span",
                                                {
                                                  style: {
                                                    color:
                                                      _vm.orderData
                                                        .orderStatus === 2
                                                        ? "red"
                                                        : "inherit",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "orderStatusFilter"
                                                        )(
                                                          _vm.orderData
                                                            .orderStatus
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                          ," +
                                                  _vm._s(
                                                    _vm._f("payStatusFilter")(
                                                      _vm.orderData.payStatus
                                                    )
                                                  ) +
                                                  "\n                          ," +
                                                  _vm._s(
                                                    _vm._f(
                                                      "shippingStatusFilter"
                                                    )(
                                                      _vm.orderData
                                                        .shippingStatus
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _vm.orderData.returnStatus === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          已退货\n                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "下单时间" } },
                                          [
                                            _vm.orderData.addTime
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("parseTime")(
                                                        _vm.orderData.addTime,
                                                        "{y}-{m}-{d} {h}:{i}:{s}"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "付款时间" } },
                                          [
                                            _vm.orderData.payTime
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("parseTime")(
                                                        _vm.orderData.payTime,
                                                        "{y}-{m}-{d} {h}:{i}:{s}"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-container",
                          [
                            _c(
                              "el-header",
                              { staticClass: "header-with-button" },
                              [
                                _c("span", { staticClass: "header-title" }, [
                                  _vm._v("收货人信息"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "auto" },
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleReceiverEdit()
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "收货人" } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.orderData.consignee
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "手机" } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.orderData.mobile) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "地址" } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.orderData.countryStr
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.orderData.provinceStr
                                                ) +
                                                "\n                        " +
                                                _vm._s(_vm.orderData.cityStr) +
                                                " " +
                                                _vm._s(
                                                  _vm.orderData.districtStr
                                                ) +
                                                " " +
                                                _vm._s(_vm.orderData.address) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c("el-header", [_vm._v("包装信息")]),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "包装" } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.orderData.packName) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "贺卡" } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.orderData.cardName) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "贺卡祝福语" } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.orderData.cardMessage
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "备注" } },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(_vm.orderData.note) +
                                                  "\n                        "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-container",
                          [
                            _c("el-header", [_vm._v("发货信息")]),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "发货单" } },
                                          [
                                            _vm.orderData.deliveryOrder
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.orderData
                                                        .deliveryOrder
                                                        .deliverySn
                                                    ) + " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "发货时间" } },
                                          [
                                            _vm.orderData.deliveryOrder &&
                                            _vm.orderData.deliveryOrder.addTime
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("parseTime")(
                                                        _vm.orderData
                                                          .deliveryOrder
                                                          .addTime,
                                                        "{y}-{m}-{d} {h}:{i}:{s}"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "骑手信息" } },
                                          [
                                            _vm.orderData.deliveryOrder
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.orderData
                                                        .deliveryOrder.riderName
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.orderData.deliveryOrder
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.orderData
                                                        .deliveryOrder
                                                        .riderPhone
                                                    ) + " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "期望时间" } },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.orderData.bestTime)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 50 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c(
                              "el-header",
                              { staticClass: "header-with-button" },
                              [
                                _c("span", { staticClass: "header-title" }, [
                                  _vm._v("商品信息"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-table",
                                  {
                                    key: 1,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.orderData.details,
                                      stripe: "",
                                      border: "",
                                      fit: "",
                                      "highlight-current-row": "",
                                      "show-summary": "",
                                      "summary-text": "合计",
                                      "summary-method": _vm.getSummaryMethod,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品名称",
                                        prop: "goodsName",
                                        align: "center",
                                        width: "150",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleViewGoods(
                                                        row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(row.goodsName))]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "图片",
                                        prop: "goodsThumbnailUrl",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              row.goodsThumbnailUrl
                                                ? _c("img", {
                                                    staticStyle: {
                                                      width: "50px",
                                                      height: "50px",
                                                      "object-fit": "cover",
                                                    },
                                                    attrs: {
                                                      src: row.goodsThumbnailUrl,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "市场价",
                                        prop: "originalPrice",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    parseFloat(
                                                      row.marketPrice
                                                    ).toFixed(2)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "售价",
                                        prop: "originalPrice",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    parseFloat(
                                                      row.originalPrice -
                                                        row.addPrice
                                                    ).toFixed(2)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "折扣",
                                        prop: "discount",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  "-" +
                                                    _vm._s(
                                                      parseFloat(
                                                        row.discount /
                                                          row.goodsNumber
                                                      ).toFixed(2)
                                                    )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "加价",
                                        prop: "",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              row.goodsMakeMethod
                                                ? _c("span", [
                                                    _c("span", [
                                                      _vm._v(
                                                        "+" +
                                                          _vm._s(
                                                            parseFloat(
                                                              row.addPrice
                                                            ).toFixed(2)
                                                          )
                                                      ),
                                                    ]),
                                                  ])
                                                : _c("span", [_vm._v("+0.00")]),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "数量",
                                        prop: "goodsNumber",
                                        align: "center",
                                        width: "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "做法",
                                        prop: "goodsAttr",
                                        align: "left",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              row.suitInfo &&
                                              row.suitInfo != "null" &&
                                              row.suitInfo !== "[]"
                                                ? _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.formatSuitInfo(row)
                                                      ),
                                                    },
                                                  })
                                                : row.goodsAttr
                                                ? _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        row.goodsAttr.replace(
                                                          /\),/g,
                                                          "),<br>"
                                                        )
                                                      ),
                                                    },
                                                  })
                                                : _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.formatNonSuitInfo(
                                                          row
                                                        )
                                                      ),
                                                    },
                                                  }),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "实付价",
                                        prop: "goodsPrice",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    parseFloat(
                                                      row.goodsPrice
                                                    ).toFixed(2)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "退货状态",
                                        prop: "isReturn",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              row.isReturn === 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    },
                                                    [_vm._v("退款")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 25 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c("el-header", [_vm._v("优惠券信息")]),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-table",
                                  {
                                    key: 2,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.orderData.coupons,
                                      stripe: "",
                                      border: "",
                                      fit: "",
                                      "highlight-current-row": "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "类型编号",
                                        prop: "typeId",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "券名称",
                                        prop: "typeName",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "天财发放批次号",
                                        prop: "thirdSendCouponId",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "天财券模板ID",
                                        prop: "thirdCouponId",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "券类型",
                                        prop: "typeGroup",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              row.typeGroup === 1
                                                ? _c("span", [_vm._v("现金券")])
                                                : row.typeGroup === 2
                                                ? _c("span", [_vm._v("折扣券")])
                                                : row.typeGroup === 3
                                                ? _c("span", [_vm._v("商品券")])
                                                : row.typeGroup === 4
                                                ? _c("span", [_vm._v("赠品券")])
                                                : row.typeGroup === 5
                                                ? _c("span", [_vm._v("免邮券")])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "优惠券金额",
                                        prop: "money",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    row.money
                                                      ? parseFloat(
                                                          row.money
                                                        ).toFixed(2)
                                                      : "0.00"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "使用张数",
                                        prop: "useCount",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 30 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c("el-header", [_vm._v("第三方优惠券信息")]),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-table",
                                  {
                                    key: 3,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.orderData.thirdBonus,
                                      stripe: "",
                                      border: "",
                                      fit: "",
                                      "highlight-current-row": "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "券码",
                                        prop: "couponCode",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "券类型",
                                        prop: "dealType",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("dealTypeFilter")(
                                                      row.dealType
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "券名称",
                                        prop: "dealTitle",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "券面值",
                                        prop: "dealValue",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "售卖价格",
                                        prop: "buyPrice",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "使用张数",
                                        prop: "useCount",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "平台",
                                        prop: "platform",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 30 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c(
                              "el-header",
                              { staticClass: "header-with-button" },
                              [
                                _c("span", { staticClass: "header-title" }, [
                                  _vm._v("费用信息"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-main", [
                              _c(
                                "div",
                                {
                                  staticClass: "cost-info",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cost-left",
                                      staticStyle: {
                                        flex: "1",
                                        "padding-right": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cost-item cost-section-title",
                                        },
                                        [_c("span", [_vm._v("菜品总付")])]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "商品总金额：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.goodsAmount || 0
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cost-item cost-section-title",
                                        },
                                        [_c("span", [_vm._v("优惠部分")])]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "  优惠券：- " +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.coupons &&
                                                    _vm.orderData.coupons
                                                      .length > 0
                                                    ? _vm.orderData.coupons.reduce(
                                                        function (sum, item) {
                                                          return (
                                                            sum +
                                                            parseFloat(
                                                              item.money || 0
                                                            )
                                                          )
                                                        },
                                                        0
                                                      )
                                                    : 0
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            " 优惠活动：- " +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.activities &&
                                                    _vm.orderData.activities
                                                      .length > 0
                                                    ? _vm.orderData.activities.reduce(
                                                        function (sum, item) {
                                                          return (
                                                            sum +
                                                            parseFloat(
                                                              item.discount || 0
                                                            )
                                                          )
                                                        },
                                                        0
                                                      )
                                                    : 0
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cost-item cost-section-title",
                                        },
                                        [_c("span", [_vm._v("额外支付")])]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            " 配送费：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.shippingFee || 0
                                                ).toFixed(2)
                                              ) +
                                              " | 餐盒费：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.boxFee || 0
                                                ).toFixed(2)
                                              ) +
                                              " | 餐具费：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.wareFee || 0
                                                ).toFixed(2)
                                              ) +
                                              " | 包装袋：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.packFee || 0
                                                ).toFixed(2)
                                              ) +
                                              " （总计：+ " +
                                              _vm._s(
                                                (
                                                  parseFloat(
                                                    _vm.orderData.shippingFee ||
                                                      0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.boxFee || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.wareFee || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.packFee || 0
                                                  )
                                                ).toFixed(2)
                                              ) +
                                              "）"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "总计金额：" +
                                              _vm._s(
                                                (
                                                  parseFloat(
                                                    _vm.orderData.goodsAmount ||
                                                      0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.shippingFee ||
                                                      0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.boxFee || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.wareFee || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.packFee || 0
                                                  ) -
                                                  (_vm.orderData.coupons &&
                                                  _vm.orderData.coupons.length >
                                                    0
                                                    ? _vm.orderData.coupons.reduce(
                                                        function (sum, item) {
                                                          return (
                                                            sum +
                                                            parseFloat(
                                                              item.money || 0
                                                            )
                                                          )
                                                        },
                                                        0
                                                      )
                                                    : 0) -
                                                  (_vm.orderData.activities &&
                                                  _vm.orderData.activities
                                                    .length > 0
                                                    ? _vm.orderData.activities.reduce(
                                                        function (sum, item) {
                                                          return (
                                                            sum +
                                                            parseFloat(
                                                              item.discount || 0
                                                            )
                                                          )
                                                        },
                                                        0
                                                      )
                                                    : 0)
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cost-right",
                                      staticStyle: {
                                        flex: "1",
                                        "padding-left": "20px",
                                        "border-left": "1px solid #eee",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cost-item cost-section-title",
                                        },
                                        [_c("span", [_vm._v("结算方式")])]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "积分抵现：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.integralMoney ||
                                                    0
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "使用余额：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.surplus || 0
                                                ).toFixed(2)
                                              ) +
                                              " (本金：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.payBenBalance ||
                                                    0
                                                ).toFixed(2)
                                              ) +
                                              " | 赠金：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData
                                                    .payGiveBalance || 0
                                                ).toFixed(2)
                                              ) +
                                              ")"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "微信/支付宝：" +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.orderData.moneyPaid || 0
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "应付款金额：" +
                                              _vm._s(
                                                (
                                                  parseFloat(
                                                    _vm.orderData.goodsAmount ||
                                                      0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.shippingFee ||
                                                      0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.boxFee || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.wareFee || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.packFee || 0
                                                  ) -
                                                  (_vm.orderData.coupons &&
                                                  _vm.orderData.coupons.length >
                                                    0
                                                    ? _vm.orderData.coupons.reduce(
                                                        function (sum, item) {
                                                          return (
                                                            sum +
                                                            parseFloat(
                                                              item.money || 0
                                                            )
                                                          )
                                                        },
                                                        0
                                                      )
                                                    : 0) -
                                                  (_vm.orderData.activities &&
                                                  _vm.orderData.activities
                                                    .length > 0
                                                    ? _vm.orderData.activities.reduce(
                                                        function (sum, item) {
                                                          return (
                                                            sum +
                                                            parseFloat(
                                                              item.discount || 0
                                                            )
                                                          )
                                                        },
                                                        0
                                                      )
                                                    : 0) -
                                                  parseFloat(
                                                    _vm.orderData
                                                      .integralMoney || 0
                                                  )
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cost-item" }, [
                                        _c("span", [
                                          _vm._v(
                                            "实付金额：" +
                                              _vm._s(
                                                (
                                                  parseFloat(
                                                    _vm.orderData.moneyPaid || 0
                                                  ) +
                                                  parseFloat(
                                                    _vm.orderData.surplus || 0
                                                  )
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 30 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-container",
                          [
                            _c("el-header", [_vm._v("操作信息")]),
                            _vm._v(" "),
                            _c(
                              "el-main",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "5px" },
                                    attrs: { label: "操作备注" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 2 },
                                      model: {
                                        value: _vm.remark,
                                        callback: function ($$v) {
                                          _vm.remark = $$v
                                        },
                                        expression: "remark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "15px" },
                                    attrs: { label: "操作" },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          disabled:
                                            !(
                                              _vm.orderData.orderStatus === 0 ||
                                              _vm.orderData.orderStatus === 1
                                            ) ||
                                            _vm.orderData.payStatus === 2 ||
                                            _vm.orderData.shippingStatus !== 0,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction("cancel")
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.handleRemark },
                                      },
                                      [_vm._v("备注")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-table",
                                  {
                                    key: 4,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.orderData.actions,
                                      stripe: "",
                                      border: "",
                                      fit: "",
                                      "highlight-current-row": "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "操作人",
                                        prop: "actionUser",
                                        align: "center",
                                        width: "150",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "操作时间",
                                        prop: "createTime",
                                        align: "center",
                                        width: "180",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              row.createTime
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("parseTime")(
                                                          row.createTime,
                                                          "{y}-{m}-{d} {h}:{i}:{s}"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "订单状态",
                                        prop: "orderStatus",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("orderStatusFilter")(
                                                      row.orderStatus
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "付款状态",
                                        prop: "payStatus",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("payStatusFilter")(
                                                      row.payStatus
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "发货状态",
                                        prop: "shippingStatus",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "shippingStatusFilter"
                                                    )(row.shippingStatus)
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "备注",
                                        prop: "actionNote",
                                        align: "center",
                                        "min-width": "100",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "收货人信息",
            visible: _vm.receiverVisible,
            size: "500px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.receiverVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "receiverFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: { model: _vm.receiverForm, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收货人", prop: "consignee" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.receiverForm.consignee,
                      callback: function ($$v) {
                        _vm.$set(_vm.receiverForm, "consignee", $$v)
                      },
                      expression: "receiverForm.consignee",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "mobile" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.receiverForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.receiverForm, "mobile", $$v)
                      },
                      expression: "receiverForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "国家", prop: "country" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "国家",
                        clearable: "",
                        filterable: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleRegionChange($event, "country")
                        },
                      },
                      model: {
                        value: _vm.receiverForm.country,
                        callback: function ($$v) {
                          _vm.$set(_vm.receiverForm, "country", $$v)
                        },
                        expression: "receiverForm.country",
                      },
                    },
                    _vm._l(_vm.countryList, function (item) {
                      return _c("el-option", {
                        key: item.regionId,
                        attrs: { label: item.regionName, value: item.regionId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "省", prop: "province" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "省",
                        clearable: "",
                        filterable: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleRegionChange($event, "province")
                        },
                      },
                      model: {
                        value: _vm.receiverForm.province,
                        callback: function ($$v) {
                          _vm.$set(_vm.receiverForm, "province", $$v)
                        },
                        expression: "receiverForm.province",
                      },
                    },
                    _vm._l(_vm.provinceList, function (item) {
                      return _c("el-option", {
                        key: item.regionId,
                        attrs: { label: item.regionName, value: item.regionId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "市", prop: "city" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "省",
                        clearable: "",
                        filterable: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleRegionChange($event, "city")
                        },
                      },
                      model: {
                        value: _vm.receiverForm.city,
                        callback: function ($$v) {
                          _vm.$set(_vm.receiverForm, "city", $$v)
                        },
                        expression: "receiverForm.city",
                      },
                    },
                    _vm._l(_vm.cityList, function (item) {
                      return _c("el-option", {
                        key: item.regionId,
                        attrs: { label: item.regionName, value: item.regionId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "区", prop: "district" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "省",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.receiverForm.district,
                        callback: function ($$v) {
                          _vm.$set(_vm.receiverForm, "district", $$v)
                        },
                        expression: "receiverForm.district",
                      },
                    },
                    _vm._l(_vm.districtList, function (item) {
                      return _c("el-option", {
                        key: item.regionId,
                        attrs: { label: item.regionName, value: item.regionId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "地址", prop: "address" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.receiverForm.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.receiverForm, "address", $$v)
                      },
                      expression: "receiverForm.address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.receiverVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleReceiverUpdate },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "收费信息",
            visible: _vm.feeVisible,
            size: "700px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.feeVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "feeFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: { model: _vm.feeForm, "label-width": "100px" },
            },
            [
              _c("div", { staticClass: "form-container" }, [
                _c(
                  "div",
                  { staticClass: "left-section" },
                  [
                    _c("el-form-item", { attrs: { label: "商品总金额" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.goodsAmount) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "发票税额" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.tax) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "配送费用" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.shippingFee) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "保价费用" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.insureFee) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "支付费用", prop: "payFee" } },
                      [
                        _c("el-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.feeForm.payFee,
                            callback: function ($$v) {
                              _vm.$set(_vm.feeForm, "payFee", $$v)
                            },
                            expression: "feeForm.payFee",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "包装费用" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.packFee) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "贺卡费用" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.cardFee) +
                          "\n            "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right-section" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "折扣", prop: "discount" } },
                      [
                        _c("el-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.feeForm.discount,
                            callback: function ($$v) {
                              _vm.$set(_vm.feeForm, "discount", $$v)
                            },
                            expression: "feeForm.discount",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "订单总金额" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.tax) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "已付款金额" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.moneyPaid) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "使用余额", prop: "surplus" } },
                      [
                        _c("el-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.feeForm.surplus,
                            callback: function ($$v) {
                              _vm.$set(_vm.feeForm, "surplus", $$v)
                            },
                            expression: "feeForm.surplus",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "使用积分", prop: "integral" } },
                      [
                        _c("el-input", {
                          attrs: { type: "number" },
                          model: {
                            value: _vm.feeForm.integral,
                            callback: function ($$v) {
                              _vm.$set(_vm.feeForm, "integral", $$v)
                            },
                            expression: "feeForm.integral",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "使用优惠券" } }),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "应付款金额" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.orderData.orderAmount) +
                          "\n            "
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.feeVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleFeeUpdate },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "添加商品",
            visible: _vm.itemAddVisible,
            size: "500px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.itemAddVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "itemAddFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: { model: _vm.itemAddForm, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品", prop: "goodsName" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: {
                        placeholder: "请输入商品名称",
                        clearable: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.handleSearchGoods,
                      },
                      on: { change: _vm.handleGoodsChange },
                      model: {
                        value: _vm.itemAddForm.goodsId,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemAddForm, "goodsId", $$v)
                        },
                        expression: "itemAddForm.goodsId",
                      },
                    },
                    _vm._l(_vm.goodsList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.goodsName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "规格", prop: "unitId" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.itemAddForm.unitId,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemAddForm, "unitId", $$v)
                        },
                        expression: "itemAddForm.unitId",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 3 } }, [_vm._v("份")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 5 } }, [_vm._v("杯")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "数量", prop: "count" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { type: "number", autosize: "" },
                    model: {
                      value: _vm.itemAddForm.count,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemAddForm, "count", $$v)
                      },
                      expression: "itemAddForm.count",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.itemAddVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: function ($event) {} },
                },
                [_vm._v("添加")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }